function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7889 33.5922C23.5415 32.8396 24.7244 32.8872 25.4294 33.5922C26.1595 34.3223 26.1595 35.5027 25.4294 36.2328C24.6994 36.9628 23.519 36.9628 22.7889 36.2328C22.0588 35.5027 22.0588 34.3223 22.7889 33.5922Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5705 33.5922C31.3231 32.8396 32.5061 32.8872 33.2111 33.5922C33.9411 34.3223 33.9411 35.5027 33.2111 36.2328C32.481 36.9628 31.3006 36.9628 30.5705 36.2328C29.8404 35.5027 29.8404 34.3223 30.5705 33.5922Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.6666 19.222C40.6331 19.222 41.4166 20.0055 41.4166 20.972V34.9137C41.4166 35.8802 40.6331 36.6637 39.6666 36.6637C38.7001 36.6637 37.9166 35.8802 37.9166 34.9137V20.972C37.9166 20.0055 38.7001 19.222 39.6666 19.222Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3333 19.222C17.2997 19.222 18.0833 20.0055 18.0833 20.972V34.9137C18.0833 35.8802 17.2997 36.6637 16.3333 36.6637C15.3668 36.6637 14.5833 35.8802 14.5833 34.9137V20.972C14.5833 20.0055 15.3668 19.222 16.3333 19.222Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.8895 19.222C32.856 19.222 33.6395 20.0055 33.6395 20.972V29.3137C33.6395 30.2802 32.856 31.0637 31.8895 31.0637C30.923 31.0637 30.1395 30.2802 30.1395 29.3137V20.972C30.1395 20.0055 30.923 19.222 31.8895 19.222Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.1104 19.222C25.0768 19.222 25.8604 20.0055 25.8604 20.972V29.3137C25.8604 30.2802 25.0768 31.0637 24.1104 31.0637C23.1439 31.0637 22.3604 30.2802 22.3604 29.3137V20.972C22.3604 20.0055 23.1439 19.222 24.1104 19.222Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3333 8.75006C12.1455 8.75006 8.75 12.1456 8.75 16.3334V39.6667C8.75 43.8546 12.1455 47.2501 16.3333 47.2501H39.6667C43.8545 47.2501 47.25 43.8546 47.25 39.6667V16.3334C47.25 12.1456 43.8545 8.75006 39.6667 8.75006H16.3333ZM5.25 16.3334C5.25 10.2126 10.2125 5.25006 16.3333 5.25006H39.6667C45.7875 5.25006 50.75 10.2126 50.75 16.3334V39.6667C50.75 45.7876 45.7875 50.7501 39.6667 50.7501H16.3333C10.2125 50.7501 5.25 45.7876 5.25 39.6667V16.3334Z",
  fill: "black"
});

function SvgBarcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.0b65e31e.svg";
export { ForwardRef as ReactComponent };